export default __webpack_public_path__ + "static/media/tpa-google.90706fa9.png";